import "./intro.css";

import { FaAward } from "react-icons/fa";

import { VscFolderLibrary } from "react-icons/vsc";
import img from '../../assets/Me.png'

// import ME from '../../assets/Rasif Tagizade image.jpg';


const Intro = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={img} alt="Rasif Taghizade" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>1+ year</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>3 Practice Projects</small>
            </article>
          </div>
          <p>
           Business Analyst Intern at Novamed Pharmaceuticals.
           While at Novamed Pharmaceuticals I introduced the first spreadsheet based database for simple, efficient and robust data driven decision making. Increased employees efficiency by creating a monthly sales tracking system and by identifying unsaturated market spaces. Moreover, I oversaw Inventory management through running daily, weekly and monthly forecasts on the demand and supply side of producs.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default Intro;
